import { isValid } from 'clients/Clients';
import { getAppConfigs } from 'clients/ConfigClient';
import { NextRouter } from 'next/router';
import { BeCustomer } from 'types/customer';
import { isJsonString } from './helper';

export const redirectToCustomerDashboard = async (userInfo: BeCustomer, router: NextRouter) => {
  if (!userInfo) return false;

  const { customerID, provinceCode } = userInfo;

  try {
    const res = await getAppConfigs({ ctx: undefined, appCode: '884FW961' });
    if (isValid(res)) {
      const config = res.data;
      const cloneData = config.reduce((preApp: any, curApp: any) => {
        const { key, object } = curApp.value;
        preApp[key] = isJsonString(object) ? JSON.parse(object) : object;
        return preApp;
      }, {});
      const GO_TO_CUSTOMER_DASHBOARD = cloneData.GO_TO_CUSTOMER_DASHBOARD;

      if (!GO_TO_CUSTOMER_DASHBOARD) return false;

      const customerIds = GO_TO_CUSTOMER_DASHBOARD.customerIds;
      const provinceCodes = GO_TO_CUSTOMER_DASHBOARD.provinceCodes;

      if ((customerIds?.includes(customerID) || provinceCodes?.includes(provinceCode)) && !!router) {
        router.replace('/dashboard');
        return true;
      }
    }
    return false;
  } catch (err) {
    return false;
  }
};

